import axios from '../../axios'

/*
 * 统考类别专业模块接口
 */

// 新增统考类别专业
export const addCategoryProf = (data) => {
    return axios({
        url: '/api/data/wish/jointCategoryProf',
        method: 'POST',
        data
    })
}

// 修改统考类别专业
export const editCategoryProf = (data) => {
    return axios({
        url: '/api/data/wish/jointCategoryProf',
        method: 'PUT',
        data
    })
}

// 删除统考类别专业
export const deleteCategoryProf = (data) => {
    return axios({
        url: '/api/data/wish/jointCategoryProf',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索统考类别专业列表
export const searchCategoryProfList = (data) => {
    return axios({
        url: '/api/data/wish/jointCategoryProf',
        method: 'GET',
        data
    })
}

// 获取统考类别专业模块详情详情
export const getCategoryProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/jointCategoryProf/info',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/tkcategoryprof.js